import {FC, ReactNode, useCallback} from 'react';
import {Button, Text} from '@mantine/core';
import {modals} from '@mantine/modals';

type DeleteButtonProps = {
  onConfirm: () => void;
  buttonLabel?: ReactNode;
  loading?: boolean;
  confirmTitle?: ReactNode;
  confirmButtonLabel?: ReactNode;
  cancelButtonLabel?: ReactNode;
};

export const DeleteButton: FC<DeleteButtonProps> = (props) => {
  const {
    onConfirm,
    buttonLabel = 'Delete',
    confirmTitle = <Text fw={600}>Are you sure?</Text>,
    confirmButtonLabel = 'Delete',
    cancelButtonLabel = 'Cancel',
    loading,
  } = props;

  const _onClick = useCallback(() => {
    modals.openConfirmModal({
      title: confirmTitle,
      onConfirm,
      labels: {cancel: cancelButtonLabel, confirm: confirmButtonLabel},
      confirmProps: {variant: 'danger'},
    });
  }, [cancelButtonLabel, confirmButtonLabel, confirmTitle, onConfirm]);

  return (
    <Button type="button" variant="danger" onClick={_onClick} loading={loading}>
      {buttonLabel}
    </Button>
  );
};